import type { SignalType } from 'types/signals'

type PaidSignalConfirmTextOptions = {
    signalType?: SignalType
    isSeed?: boolean
}

export type PaidSignalConfirmTextItem = {
    icon: 'arrow-big-up' | 'rocket' | 'repeat-2'
    text: string
    strongText: string
}

export const paidSignalActionLabel = (_signalType?: SignalType) => 'Upvalue'

export const paidSignalConfirmText = (
    options: PaidSignalConfirmTextOptions = {},
): PaidSignalConfirmTextItem[] => {
    if (options.isSeed) {
        return [
            {
                icon: 'arrow-big-up',
                text: "Half of your Seed goes to the message's author.",
                strongText: 'Half',
            },
            {
                icon: 'repeat-2',
                text: 'Half of your Seed goes to earlier seeders. When seeding, it pays to be early. The first seed, goes to Treechat.',
                strongText: 'earlier seeders',
            },
            {
                icon: 'rocket',
                text: 'Seeding reposts the message to the top of the feed, where it can attract more support.',
                strongText: 'reposts',
            },
        ]
    }

    return [
        {
            icon: 'arrow-big-up',
            text: "Upvaluing another user's message sends them a micropayment (Treechat takes a 15% fee so we don't have to show you ads).",
            strongText: 'Upvaluing',
        },
        {
            icon: 'rocket',
            text: 'Upvaluing your own message is called Boosting and sends a micropayment to Treechat.',
            strongText: 'Boosting',
        },
        {
            icon: 'repeat-2',
            text: 'Upvaluing or Boosting any message reposts it to the top of the feed where it has a chance to earn more upvalue.',
            strongText: 'reposts',
        },
    ]
}
